module.exports = __webpack_public_path__ + "img/136.2.eacf41e7.png";